const handleCopyImg = (imgSrc, callback, imgWidth = '100', imgHeight = '100') => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();

  canvas.width = imgWidth;
  canvas.height = imgHeight;

  img.crossOrigin = 'Anonymous';
  img.src = imgSrc;

  img.onload = () => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

    // 将canvas转为blob
    canvas.toBlob(async (blob) => {
      // console.log(blob);
      const data = [
        // eslint-disable-next-line no-undef
        new ClipboardItem({
          [blob.type]: blob,
        }),
      ];

      await navigator.clipboard.write(data)
        .then(
          () => {
            // console.log('复制成功!');
            callback();
          },
          () => {
            console.error('写入剪贴板失败!');
          }
        );
    });
  };
};

export default handleCopyImg;
